import intersectEffects from "./intersectEffects";

export default () => ({
    cheight: 0, 
    cwidth: 0, 
    words: [],
    speed: 0,
    index: 0,
    init() {
        this.words = this.$el.dataset.words.split('|');
        this.cheight = this.$refs.pretitle.offsetHeight;
        this.cwidth = this.$refs.first.offsetWidth;
        this.speed = this.$el.dataset.speed;
        this.switcheroo()
        this.$watch('cheight', value => { this.updateStyles() })
        this.$watch('cwidth', value => { this.updateStyles() })
    },
    start() {
        this.updateStyles()
        // if(document.querySelector('.titlecycler_cycler').length) {
        setInterval(() => {
            this.$refs.first.classList.add('shift');
            this.$refs.second.classList.add('shift');
            this.cwidth = this.$refs.second.offsetWidth;
            this.switcheroo();
        }, this.speed);
    // }
    },

    switcheroo() {
        setTimeout(() => {
            this.$refs.first.classList.remove('shift')
            this.$refs.second.classList.remove('shift')
            
            this.$refs.first.innerText = this.words[this.index];
            if(this.index >= this.words.length - 1) {
                this.$refs.second.innerText = this.words[0];
            } else {
                this.$refs.second.innerText = this.words[this.index + 1];
            }
            
            // this.cwidth = this.$refs.second.offsetWidth;
            
            if(this.index >= this.words.length - 1) {
                this.index = 0;
            } else {
                this.index++;
            }
            
        }, 300);
    },
    updateStyles() {
        this.$refs.container.style.height = this.cheight + 'px'
        this.$refs.container.style.width = this.cwidth + 'px'
    },
    ... intersectEffects()
})